import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { jwtDecode } from 'jwt-decode';


export const AuthContext = React.createContext();

const AuthProvider = props => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [user, setUser] = useState({});
  const [token, setToken] = useState(null);
  const [expDate, setExpDate] = useState(null);
  const [check, setCheck] = useState(false);

  const clearLocalStorage = () => {
    setUser(null);
    setLoggedIn(false);
    setToken(null);
    setExpDate(null);
    localStorage.removeItem('userData');
  };

  const signIn = useCallback(({ token, user }) => {
    if (user) setUser(user);
    if (token) {
      const decodedToken = jwtDecode(token);
      setLoggedIn(true);
      setToken(token);
      setExpDate(decodedToken.exp);

      localStorage.setItem(
        'userData',
        JSON.stringify({
          user,
          token,
          loggedIn: true,
          expDate: decodedToken.exp,
        }),
      );

      if (new Date(decodedToken.exp * 1000) <= new Date()) {
        clearLocalStorage();
      }
    }
  }, []);

  const editUserData = newUserdata => {
    const userData = JSON.parse(localStorage.getItem('userData'));
    if (userData) {
      userData.user = newUserdata;
      localStorage.setItem('userData', JSON.stringify(userData));
      setUser(newUserdata);
    }
  };

  useEffect(() => {
    console.log('checking session...');
    if (expDate && new Date(expDate * 1000) <= new Date()) {
      clearLocalStorage();
    }
    const interval = setInterval(() => {
      if (expDate && new Date(expDate * 1000) > new Date()) {
        setCheck(prevCheck => !prevCheck);
      }
    }, 5000);

    return () => clearInterval(interval);
  }, [check, expDate]);

  useMemo(() => {
    const userData = JSON.parse(localStorage.getItem('userData'));
    if (userData) {
      signIn({ token: userData.token, user: userData.user });
    }
  }, [signIn]);

  return (
    <AuthContext.Provider
      value={{
        loggedIn,
        clearLocalStorage,
        signIn,
        user,
        setUser,
        token,
        editUserData,
      }}
    >
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
